import { AddToCalendar } from './addToCalendar'
import { PubSub } from '../../../lib/models/pubSub'
import { StoreHelper } from './storeHelper'

const PubSubHelper = {
  install(Vue: any, options: any) {
    if (Vue.config && Vue.config.globalProperties) { // Vue3
      Vue.config.globalProperties.$pubSub = PubSub.getInstance(options)
    } else if (Vue.prototype) { // Vue2
      Vue.prototype.$pubSub = PubSub.getInstance(options)
    }
  }
}

export default {
  AddToCalendar,
  PubSub,
  PubSubHelper,
  StoreHelper,
}
export {
  AddToCalendar,
  PubSub,
  PubSubHelper,
  StoreHelper,
}
